import Component from "@ember/component";
// Exists so plugins can use it
export default Component.extend();
